import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../actions/actionCreators.js";


import RiskAssessment from "../components/RiskAssessment";


function mapStateToProps(state){
	//console.log("Connecting state", state.series);
	return {
		lang: state.data.lang,
		rank: state.data.userInfo.rank,
		firm: state.data.userInfo.firm,
		auth: state.data.auth,
	}
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(actionCreators, dispatch);
}


const RiskAssessmentContainer = connect(mapStateToProps, mapDispatchToProps)(RiskAssessment);

export default RiskAssessmentContainer;


// WEBPACK FOOTER //
// ./src/containers/RiskAssessmentContainer.js